<template>
  <div class="ml8 mr8 mb16">
    <div class="flex yxtbiz-rank-list__horizontal-head">
      <div
        v-for="(item, index) of horizontalHeadImgs"
        :key="index"
        :style="'width:' + (item.order ? 13 / 41 : 15 / 41) * 100 + '%'"
      >
        <div
          :class="[
            'yxtbiz-rank-list__horizontal-head-item' + item.order,
            !contentObj.hasHead && !item.order ? 'pt8' : '',
            item.order && !rankData[item.order]
              ? 'yxtbiz-rank-list__horizontal-head-item-hide' +
                (contentObj.hasHead ? '-head' : '') +
                item.order
              : ''
          ]"
          class="yxtbiz-rank-list__horizontal-head-item"
          :style="
            'background-image: url(' +
            sspImgCdn +
            (rankData[item.order] &&
            rankData[item.order].rankOrder !== item.order + 1
              ? horizontalHeadImgs[
                  rankData[item.order].rankOrder === 2
                    ? 0
                    : rankData[item.order].rankOrder
                ].bg
              : item.bg) +
            ');'
          "
        >
          <div v-if="rankData[item.order]">
            <!-- 有头像的名次 -->
            <div
              v-if="contentObj.hasHead"
              class="
                clearfix
                yxtbiz-rank-list__horizontal-head-portrait-order-box
              "
            >
              <div
                class="flex yxtbiz-rank-list__horizontal-head-portrait-order"
              >
                <yxtf-image
                  :src="
                    sspImgCdn +
                    (rankData[item.order].rankOrder !== item.order + 1
                      ? horizontalHeadImgs[
                          rankData[item.order].rankOrder === 2
                            ? 0
                            : rankData[item.order].rankOrder
                        ].crown
                      : item.crown)
                  "
                  class="yxtbiz-rank-list__horizontal-head-crown"
                />
                <div
                  class="yxtbiz-rank-list__horizontal-head-portrait"
                  :class="[
                    disabledSkip(item.order)
                      ? 'cursor-default'
                      : 'cursor-point',
                    item.order &&
                    rankData[item.order].rankOrder !== item.order + 1
                      ? 'yxtbiz-rank-list__horizontal-head-portrait-bg' +
                        rankData[item.order].rankOrder
                      : ''
                  ]"
                  @click="
                    !disabledSkip(item.order) &&
                      linkToUserIndex(rankData[item.order].userId)
                  "
                >
                  <yxtf-portrait
                    v-if="contentObj.objectCode === dictionaryKeys.user"
                    :size="item.order ? '48px' : '80px'"
                    :img-url="rankData[item.order][dictionaryKeys.userImgUrl]"
                    :username="
                      rankData[item.order][dictionaryKeys.userName] || ''
                    "
                  />
                  <div
                    v-else
                    class="yxtbiz-rank-list__horizontal-head-dept-icon"
                    :class="[
                      rankData[item.order].rankOrder < 4
                        ? 'yxtbiz-rank-list__horizontal-head-dept-icon' +
                          rankData[item.order].rankOrder
                        : '',
                        !item.order ? 'yxtbiz-rank-list__horizontal-head-dept-icon-golden' : ''
                    ]"
                  >
                    <yxtf-svg
                      :width="item.order ? '24px' : '46px'"
                      :height="item.order ? '24px' : '46px'"
                      icon-class="department"
                    />
                  </div>
                </div>
                <div
                  class="yxtbiz-rank-list__horizontal-head-portrait-order-svg"
                >
                  <yxt-svg
                    width="24px"
                    height="24px"
                    :remote-url="sspSvgCdn"
                    :icon-class="'rank_no' + rankData[item.order].rankOrder"
                  />
                </div>
              </div>
            </div>
            <!-- 没有头像的名次 -->
            <div
              v-else
              class="yxtbiz-rank-list__horizontal-head-order"
              :class="[
                item.order && rankData[item.order].rankOrder !== item.order + 1
                  ? 'yxtbiz-rank-list__horizontal-head-order-shadow' +
                    rankData[item.order].rankOrder
                  : ''
              ]"
            >
              <yxt-svg
                width="24px"
                height="24px"
                :remote-url="sspSvgCdn"
                :icon-class="'rank_no' + rankData[item.order].rankOrder"
              />
            </div>
            <!-- 姓名、部门、平台等 -->
            <div class="yxtbiz-rank-list__horizontal-head-content">
              <!-- 主要显示的内容 -->
              <div
                v-if="contentObj.primaryCode"
                @click="
                  !disabledSkip(item.order) &&
                    linkToUserIndex(rankData[item.order].userId)
                "
              >
                <primary-content
                  :class="
                    disabledSkip(item.order) ? 'cursor-default' : 'cursor-point'
                  "
                  class="yxtf-weight-6 lh24 font-size-16"
                  fromHor
                  :code="contentObj.primaryCode"
                  :name="rankData[item.order][contentObj.primaryCode]"
                />
              </div>
              <!-- 次要显示的内容 -->
              <secondary-content
                v-if="
                  contentObj.secondaryCodes && contentObj.secondaryCodes.length
                "
                :codes="contentObj.secondaryCodes"
                :contents="rankData[item.order]"
                class="text-8c"
              />
            </div>
            <!-- 属性对应的值 -->
            <div
              v-if="contentObj.attributeCode"
              class="
                standard-size-14
                text-26
                mt8
                yxtbiz-rank-list__horizontal-head-content
              "
            >
              <yxtf-tooltip
                placement="top"
                open-filter
                class="ellipsis"
                :content="numberUnit(rankData[item.order].rankValue)"
              >
                <div>{{ numberUnit(rankData[item.order].rankValue) }}</div>
              </yxtf-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  horizontalHeadImgs,
  sspSvgCdn,
  sspImgCdn,
  dictionaryKeys,
  linkToUserIndex,
  numberUnit
} from '../config';
import primaryContent from './primaryContent.vue';
import secondaryContent from './secondaryContent.vue';

export default {
  components: {
    secondaryContent,
    primaryContent
  },
  props: {
    // 榜单数据
    rankData: {
      type: Array,
      default: []
    }
  },
  inject: ['contentFun'],
  computed: {
    // 显示内容数据
    contentObj() {
      return this.contentFun();
    }
  },
  data() {
    return {
      sspSvgCdn,
      sspImgCdn,
      horizontalHeadImgs,
      dictionaryKeys,
      linkToUserIndex,
      numberUnit
    };
  },
  methods: {
    // 当前数据里的机构不是用户所登录的机构/榜单的对象不是学员,不能跳转用户中心
    disabledSkip(order) {
      return (
        (this.rankData[order] &&
          this.rankData[order].orgId &&
          this.rankData[order].orgId !== localStorage.orgId) ||
        this.contentObj.objectCode !== this.dictionaryKeys.user
      );
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
